import qs from 'query-string'
import { useState, useEffect } from 'react'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { isNil, uniqBy } from 'lodash'

import { useInfinityScrollSimple } from 'hooks'
import { useListUserFollowersQuery } from 'store/api/yay/user'
import { User } from 'lib/_types'

import Loading from 'components/Loading'
import LoadMore from 'components/LoadMore'
import { Link } from 'features/i18n/router'
import { UserList } from 'components'

const FollowerListModal = () => {
  const location = useLocation()
  const { t } = useTranslation()

  let userId = qs.parse(location.search)?.userId

  if (Array.isArray(userId)) {
    // just in case of malformed duplicate userId queries
    userId = userId[0]
  }

  const [__fromFollowId, __fromFollowIdSet] = useState<string>('0')
  const [__userFollowers, __userFollowersSet] = useState<Array<User>>([])

  const usersFollowersRes = useListUserFollowersQuery(
    {
      userId,
      fromFollowId: __fromFollowId,
    },
    { skip: isNil(userId.match(/^\d+$/)) }
  )

  const loadMore = () => {
    __fromFollowIdSet(usersFollowersRes?.data?.last_follow_id?.toString?.())
  }

  const { loadMoreRef } = useInfinityScrollSimple({
    loadMore,
  })

  useEffect(() => {
    __userFollowersSet(
      uniqBy(
        [
          ...__userFollowers?.map?.((x) => {
            return (
              usersFollowersRes?.data?.users?.find?.((y) => y?.id == x?.id) ?? x
            )
          }),
          ...(usersFollowersRes?.data?.users ?? []),
        ],
        (x) => x?.id
      )
    )
  }, [usersFollowersRes])

  return (
    <div className="Modal__wrapper">
      <div className="Modal__header">
        <Link className="Modal__header__close" to={location.pathname} />

        <h2 className="Modal__header__h2">{t('common.follower')}</h2>
      </div>

      <div className="Modal__body">
        {usersFollowersRes?.isLoading && <Loading />}

        {__userFollowers?.length > 0 && (
          <>
            <UserList
              users={__userFollowers}
              fullWidth
              followFrom="follower_list"
              followCallbackSetter={__userFollowersSet}
            />

            <LoadMore
              isLoading={usersFollowersRes?.isFetching}
              hidden={isNil(usersFollowersRes?.data?.last_follow_id)}
              className="LoadMore--bd-t"
              onClick={() => {
                loadMore()
              }}
              ref={loadMoreRef}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default FollowerListModal
